import { config } from "../../config"
import { LoginResult, MinimalUser } from "./data-types"

export const registerEmail = async (
    first_name: string,
    last_name: string,
    email: string, 
    password: string, 
    picture: Blob | null,
    language: string,
): Promise<LoginResult> => {
    try {
        const reqBody = new FormData()
        reqBody.append("first_name", first_name)
        reqBody.append("last_name", last_name)
        reqBody.append("email", email)
        reqBody.append("password", password)
        reqBody.append("language", language)
        if (picture) {
            reqBody.append("picture", picture!)
        }

        const res = await fetch(`${config.api.urlV1}/sign-up/`, {
            method: 'POST',
            body: reqBody,
        })

        if (res.status > 300) {
            const body = await res.json()

            return {
                error: body.error
            }
        }

        const body: MinimalUser & { token: string } = await res.json()

        return {
            userToken: {
                user: body,
                token: {
                    access: body.token,
                    refresh: "",
                }
            }
        }
    } catch (e) {
        return {
            error: e as string
        }
    }
}
